// extracted by mini-css-extract-plugin
module.exports = {"component":"FilterCheckboxes_component__ht9C8","checkboxes":"FilterCheckboxes_checkboxes__udZtG","label":"FilterCheckboxes_label__66ZdJ"};